import { DonutChart } from '@mantine/charts';

const DonutChartDefaults = DonutChart.extend({
  defaultProps: {
    withTooltip: false,
    strokeWidth: 0,
    startAngle: 90,
    endAngle: -360,
  },
  classNames: {},
});

export { DonutChart, DonutChartDefaults };
